/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setStaffDetails } from 'actions/staffDetailsAction';
import FSBModal from 'components/common/FSBModal';
import StaffDetails from './components/StaffDetails';

const StaffDetailsDrawer = () => {
  const dispatch = useDispatch();
  const { status, selectedStaff } = useSelector(
    (state) => state.staffDetailsReducer,
  );
  const drawerToggle = () => {
    dispatch(setStaffDetails({ status: false, selectedStaff: null }));
  };
  useEffect(() => {
    dispatch(setStaffDetails({ status: false, selectedStaff: null }));
  }, []);

  window.addEventListener('popstate', () => {
    drawerToggle();
  });

  return (
    <div>
      {' '}
      {status && (
        <FSBModal
          open={status}
          size="xl"
          title="Staff Details"
          closeButtonLabel=""
          confirmButtonLabel=""
          message=""
          toggleAlert={drawerToggle}
          onClose={drawerToggle}
          onConfirmClick={drawerToggle}
          modalClass="right-drawer right-drawer-details"
        >
          <StaffDetails
            staffId={selectedStaff?.id}
            drawerToggle={drawerToggle}
          />
        </FSBModal>
      )}
    </div>
  );
};

export default StaffDetailsDrawer;
